/* Nixie count-up: on first view, counts 0 -> real number with an ease-out landing (~2.3s).
   Only swaps which cathode is lit; tube count/width never changes. The wrapper's aria-label
   always holds the real number. No-JS / reduced motion: the server-rendered final number stays. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
  var DURATION = 2300, DELAY = 250;
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function setup(el) {
    if (el.dataset.nxInit) return;
    el.dataset.nxInit = '1';
    var target = parseInt(el.getAttribute('data-count'), 10);
    var tubes = Array.prototype.slice.call(el.querySelectorAll('.vas-nx2__tube'));
    var commas = Array.prototype.slice.call(el.querySelectorAll('[data-comma]'));
    if (!target || !tubes.length) return;
    var n = tubes.length;
    var lits = tubes.map(function (t) { return Array.prototype.slice.call(t.querySelectorAll('.vas-nx2__lit use')); });
    var shown = tubes.map(function (t) { return t.getAttribute('data-digit'); });
    /* comma positions: number of tubes to the right of each comma */
    var commaRight = commas.map(function (c) {
      var k = 0, s = c.nextElementSibling;
      while (s) { if (s.classList.contains('vas-nx2__tube')) k++; s = s.nextElementSibling; }
      return k;
    });

    function render(v) {
      var str = String(v), len = str.length;
      for (var i = 0; i < n; i++) {
        var pos = n - 1 - i;              /* place value index from the right */
        var on = pos < len;
        tubes[i].classList.toggle('is-off', !on);
        if (!on) continue;
        var d = str.charAt(len - 1 - pos);
        if (shown[i] !== d) {
          shown[i] = d;
          for (var u = 0; u < lits[i].length; u++) lits[i][u].setAttribute('href', '#vasNxD' + d);
        }
      }
      for (var c = 0; c < commas.length; c++) commas[c].classList.toggle('is-off', len <= commaRight[c]);
    }

    render(0);
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      setTimeout(function () {
        var start = null;
        function frame(ts) {
          if (start === null) start = ts;
          var t = Math.min(1, (ts - start) / DURATION);
          render(Math.round(target * easeOutQuart(t)));
          if (t < 1) requestAnimationFrame(frame); else render(target);
        }
        requestAnimationFrame(frame);
      }, DELAY);
    }, { threshold: 0.5 });
    io.observe(el);
  }

  function boot() { document.querySelectorAll('.vas-nx2[data-count]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
